<div class="h-[calc(100vh-81px)] bg-background-dark-00 p-4 flex flex-col overflow-y-auto" *ngIf="lots()">
    <div class="flex justify-end">
        <div class="px-4 py-3 cursor-pointer" (click)="goBack()">
            <img src="assets/icons/close-white.svg" alt="Close" />
        </div>
    </div>
    <div class="flex-1 flex flex-col gap-4 md:gap-10">
        <ng-container *ngIf="lots().length > 0 && colorInfo()">
            <div class="px-[16px] md:px-[60px] lg:px-[120px]">
                <div class="flex flex-wrap flex-col justify-between md:flex-row gap-4 ">
                    <div class="flex flex-wrap gap-2 items-baseline">
                        <span class="typography-title-l text-text-inverse">
                            {{'natural_stone.lot' | translate}}&nbsp;{{getCurrentLot().lotId}}
                        </span>
                        <span class="body-l-medium text-text-inverse">
                            {{colorText}}
                        </span>
                        <span class="typography-body-l-regular text-text-inverse">
                            {{(getThickness() | number: '1.0-1')}} cm | {{finishText}}
                        </span>
                    </div>
                    <div class="flex gap-2">
                        <div class="cursor-pointer" (click)="downloadImage()">
                            <img src="assets/icons/download-white.svg" alt="Download" />
                        </div>
                        <div class="cursor-pointer" (click)="zoomIn()">
                            <img src="assets/icons/zoom-in-white.svg" alt="Zoom in" />
                        </div>
                        <div class="cursor-pointer" (click)="zoomOut()">
                            <img src="assets/icons/zoom-out-white.svg" alt="Zoom out" />
                        </div>
                    </div>
                </div>
                <div class="border-b border-text-inverse mt-6">

                </div>
            </div>
            <div class="flex-1 flex items-center " [ngClass]="{'px-[16px] md:px-[60px] lg:px-[120px]': lots().length <= 1}">
                <div *ngIf="lots().length > 1" (click)="changeLot(lotIndex - 1)">
                    <img class="max-h-[60px] lg:max-h-[120px]" src="assets/icons/chevron-big-left.svg" alt="Previous" />
                </div>
                <div class="flex-1 h-full min-h-[300px]">
                    <app-image-viewer [imageSrc]="imageUrl" [zoom]="zoom"></app-image-viewer>
                </div>
                <div *ngIf="lots().length > 1" (click)="changeLot(lotIndex + 1)">
                    <img class="max-h-[60px] lg:max-h-[120px]" src="assets/icons/chevron-big-right.svg" alt="Next">
                </div>
            </div>
            <div class="px-[16px] md:px-[60px] lg:px-[120px] grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 text-text-inverse">
                <div class="col-span-1 flex flex-col gap-1 sm:gap-2">
                    <p class="m-0 typography-body-m-light text-text-inverse">
                        {{'global.size' | translate}}: {{getWidth()  | number: '1.0-2'}}{{'x'}}{{getHeight() | number: '1.0-2'}}{{getMeasureUnit()}}
                    </p>
                    <p class="m-0 typography-body-m-light text-text-inverse">
                        {{'global.surface_area' | translate}}: {{getSurfaceArea() | number: '1.0-2'}}{{getSurfaceAreaMeasure()}}
                    </p>
                </div>
                <div class="col-span-1 flex flex-col gap-1 sm:gap-2">
                    <p class="m-0 typography-body-m-light text-text-inverse">
                        {{'global.available_units' | translate}}: {{getAvailableSlabs()}}
                    </p>
                    <p *ngIf="getCurrentLot().bundleId" class="m-0 typography-body-m-light text-text-inverse">
                        {{'natural_stone.bundle_id' | translate}}: {{getCurrentLot().bundleId}}
                    </p>
                </div>
                <div class="col-span-1 sm:col-span-2 lg:col-span-1 flex gap-4 md:gap-6">
                    <div class="flex-1">
                        <app-number-stepper
                            [min]="getAvailableSlabs() > 0 ? 1 : 0"
                            [max]="getAvailableSlabs()"
                            (valueChange)="qtyToAddToCartChanged($event)"

                        ></app-number-stepper>
                    </div>
                    <div class="flex-1">
                        <app-button
                            [size]="'large'"
                            [disabled]="qtyToAddToCart <= 0"
                            [isFullWidth]="true"
                            (click)="addToCart()"
                        >
                            {{'global.add' | translate}}
                        </app-button>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>